import { render, staticRenderFns } from "./HomeOnboarding.vue?vue&type=template&id=6c549ae1&scoped=true&"
import script from "./HomeOnboarding.vue?vue&type=script&lang=js&"
export * from "./HomeOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./HomeOnboarding.vue?vue&type=style&index=0&id=6c549ae1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c549ae1",
  null
  
)

export default component.exports